// speichernUnter.ts — T-236: „Speichern unter …" für eine Datei aus KMVS.
//
// Edge legt einen normalen Download ohne Nachfrage im Download-Ordner ab; den
// Dialog mit Ordnerwahl gibt es nur über `showSaveFilePicker` (Edge/Chromium).
// Wo die Schnittstelle fehlt, bleibt der gewöhnliche Download.

type SaveFilePicker = (o: {
    suggestedName?: string;
    types?: Array<{ description?: string; accept: Record<string, string[]> }>;
}) => Promise<{ createWritable: () => Promise<{ write: (b: Blob) => Promise<void>; close: () => Promise<void> }> }>;

/** `true` = gespeichert bzw. Download angestoßen, `false` = der Nutzer hat abgebrochen. */
export async function speichereBlobUnter(blob: Blob, name: string): Promise<boolean> {
    const picker = (window as unknown as { showSaveFilePicker?: SaveFilePicker }).showSaveFilePicker;
    if (typeof picker === "function") {
        try {
            const endung = /\.[a-z0-9]{1,8}$/i.exec(name)?.[0];
            const handle = await picker({
                suggestedName: name,
                ...(blob.type && endung ? { types: [{ accept: { [blob.type]: [endung] } }] } : {}),
            });
            const ziel = await handle.createWritable();
            await ziel.write(blob);
            await ziel.close();
            return true;
        } catch (err) {
            // Abbrechen im Dialog ist kein Fehler.
            if (err instanceof DOMException && err.name === "AbortError") return false;
            // Alles andere (z. B. Schnittstelle im eingebetteten Fenster gesperrt):
            // unten den gewöhnlichen Download nehmen.
        }
    }
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = name;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.setTimeout(() => URL.revokeObjectURL(url), 0);
    return true;
}
